export const AUDIO_EXTERNAL = 'AUDIO_EXTERNAL';
export const VIDEO = 'VIDEO';
export const FACE_TO_FACE = 'FACE_TO_FACE';
